export const BRAND = {
  name: "Peace Trucking LLC",
  phone: "818-404-7455",
  phoneHref: "tel:8184047455",
  email: "cj@peacetruckingllc.com",
  instagram: "peacetruckingllc",
  instagramUrl: "https://instagram.com/peacetruckingllc",
  address: "5015 Lancaster, SC 29720",
  dot: "4292223",
  mc: "167332",
  owner: "Charles Ransom",
  logo: "https://static.prod-images.emergentagent.com/jobs/47ac4723-9cf3-4221-866f-1fcc720b9434/images/aab1fec8f9df42e15ae68e025157f88ec1354a542f205b29c56b34a738ed686d.png",
};

export const IMAGES = {
  heroTruck: "https://images.pexels.com/photos/11053643/pexels-photo-11053643.jpeg",
  freightBW: "https://images.unsplash.com/photo-1578857371787-189d8b9eda84",
  sprinter: "https://images.pexels.com/photos/19871522/pexels-photo-19871522.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  medical: "https://images.pexels.com/photos/8942528/pexels-photo-8942528.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ceo: "https://customer-assets-4nw71qhi.emergentagent.net/job_peace-logistics/artifacts/rln6mrrd_FullSizeRender.webp",
};

export const SERVICES = [
  {
    id: "freight",
    n: "01",
    title: "Local & Cross-Country Freight",
    desc: "Full tractor-trailer capacity moving goods across the block or across the nation — tracked, insured, and delivered with discipline.",
    tags: ["Tractor Trailers", "FTL", "Nationwide"],
  },
  {
    id: "elderly",
    n: "02",
    title: "Elderly & Medical Transport",
    desc: "Compassionate non-emergency medical transport and delivery for elderly clients. Comfort, dignity, and punctuality on every mile.",
    tags: ["NEMT", "Wheelchair Ready", "Door-to-Door"],
  },
  {
    id: "mental",
    n: "03",
    title: "Mental Health Service Transport",
    desc: "Reliable pickup and delivery for mental health and recovery programs — coordinated with providers, handled with discretion and care.",
    tags: ["Provider Coordinated", "Recovery Support", "Discreet"],
  },
  {
    id: "sprinter",
    n: "04",
    title: "Sprinter Van Delivery",
    desc: "Agile last-mile and expedited delivery in our premium Sprinter fleet — perfect for time-sensitive and specialized cargo.",
    tags: ["Last Mile", "Expedited", "Specialized"],
  },
];
